import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Shield — account security. */
export function ShieldIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M12 3.8 5.4 6.4v5.4c0 4.1 2.8 6.9 6.6 8.4 3.8-1.5 6.6-4.3 6.6-8.4V6.4L12 3.8Z" />
      <path d="M9.2 11.8l2 2 3.6-4" />
    </PortalIcon>
  );
}
